let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3wLCJ")).then(() => parcelRequire('dCT0T'));